var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2635 0.5L16.9706 1.20711L14.8 3.37771L9.63426 8.54348L8.85165 9.32609L2.00003 16.1777L0.707107 17.4706L0 16.7635L16.2635 0.5Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 3.37771V1.5H5.20003V8.54348H9.63426L14.8 3.37771ZM14.8 4.79192L11.0485 8.54348H14.8V4.79192ZM4.40003 9.32609H8.85165L2.00003 16.1777V11.6739C2.00003 10.3748 3.07203 9.32609 4.40003 9.32609ZM3.22238 16.3696H5.20003V19.5H14.8V16.3696H18V11.6739C18 10.3748 16.928 9.32609 15.6 9.32609H10.2659L3.22238 16.3696ZM13.2 17.9348H6.80003V14.0217H13.2V17.9348ZM15.6 12.4565C15.16 12.4565 14.8 12.1043 14.8 11.6739C14.8 11.2435 15.16 10.8913 15.6 10.8913C16.04 10.8913 16.4 11.2435 16.4 11.6739C16.4 12.1043 16.04 12.4565 15.6 12.4565Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintDisabled);
export default __webpack_public_path__ + "static/media/PrintDisabled.dedc6366400af629105c6889c4b15248.svg";
export { ForwardRef as ReactComponent };